module.exports = __webpack_public_path__ + "static/media/376JamesPBrawleyDrNW_2018-06-11_75.a695451d.jpg";